<div class="relative">
  <nz-table
    #Table 
    nzOuterBordered 
    nzShowSizeChanger
    nzShowPagination 
    [nzData]="dataList"
    [nzFrontPagination]="false" 
    nzSize="small"
    [nzScroll]="{x: options.width? options.width +'px' : '', y: options.isScrollTable ? this.options.height - 36 + 'px' : ''}" 
    class="absolute w-full" 
    [nzTotal]="options.total" 
    [nzPageSize]="options.nzPageSize" 
    [nzPageIndex]="options.nzPageIndex" 
    [nzPageSizeOptions]="options.nzPageSizeOptions"
    (nzPageIndexChange)="pageIndexHanlder($event)" 
    (nzPageSizeChange)="pageSizeHanlder($event)"
    (nzCurrentPageDataChange)="options.isCheckBoxCol === true ? onCurrentPageDataChange($event) : ''"
    [nzLoading]="isLoading"
    [nzShowTotal]="rangeTemplate"
    >
    <thead>
      <tr #pageHeaderTable>
          <th
            *ngIf="options.isCheckBoxCol"
            nzLeft 
            [nzWidth]="50 + 'px'" 
            [(nzChecked)]="checked"
            [nzIndeterminate]="indeterminate"
            (nzCheckedChange)="onAllChecked($event)"
          >
          </th>
        <th
          *ngIf="options.isIndexCol"
          [nzWidth]="50 + 'px'" 
          [nzLeft]="options.numbernzLeft >= 1? true: false" 
          nzAlign="center"
          >
          STT
        </th>
        <ng-container *ngFor="let col of options.columns; let i = index">
          <th
            *ngIf="col.display == false ? false : true" 
            [nzWidth]="col.width != null ? col.width : null" 
            [nzRight]="options.numbernzRight >= isIndexRight(i) ? true : false"
            [nzLeft]="options.numbernzLeft > isIndexLeft(i) ? true : false"
            [nzAlign]="col.align"
            [nzSortFn]="col.sortFn"
            [nzSortPriority]="col.priority"
          >
            {{ col.columnName }}
            <ng-container *ngIf="col.colIcon"> 
              <i nz-icon [nzType]="col.colIcon" [nzTheme]="col.colIconTheme"></i>
            </ng-container>
          </th>
        </ng-container>
        <th *ngIf="options.isBtnCol" 
            [nzWidth]="widthBntCol + 'px'" 
            [nzRight]="options.numbernzRight >= 1 ? true : false ">
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of Table.data; let i = index" [style.fontWeight]="data.isRead === false ? 'bold' : ''">
        <ng-container *ngIf="options.isCheckBoxCol">
          <td nzLeft
            [nzChecked]="setOfCheckedId.has(data.id)" 
            (nzCheckedChange)="onItemChecked(data.id, $event)"
            >
          </td>
        </ng-container>
        <td
          *ngIf="options.isIndexCol" 
          [nzLeft]="options.numbernzLeft >= 1? true : false"
          nzAlign="center"
          >
          {{ i + 1 + (options.nzPageIndex-1)*options.nzPageSize }}
        </td>
        <ng-container *ngFor="let colvalue of options.columns; let j = index">
          <td 
            *ngIf="colvalue.display == false ? false : true"
            [nzRight]="options.numbernzRight >= isIndexRight(j) ? true : false"
            [nzLeft]="options.numbernzLeft > isIndexLeft(j) ? true : false"
            [nzAlign]="colvalue.align"
            nz-tooltip [nzTooltipTitle]="colvalue.isTooltip? data[colvalue.key]:''" 
          > 
            <ng-container *ngIf="colvalue.isPipe && data[colvalue.key] !== false &&  data[colvalue.key]  !== true">
              {{ data[colvalue.key] | dynamicPipe: colvalue.pipe : colvalue.agrPipe }}
            </ng-container>
            <ng-container *ngIf="!colvalue.isPipe && data[colvalue.key] !== false &&  data[colvalue.key]  !== true && colvalue.key !== 'color'">
              <a *ngIf="colvalue.isLink" (click)="colvalue.handlerLink(data)" class="text-hidden">
                {{ data[colvalue.key] }}
              </a>
              <ng-container *ngIf="!colvalue.isLink">
                {{ data[colvalue.key] }}
              </ng-container>
            </ng-container>
            <ng-container *ngIf="data[colvalue.key] === true">
              <table-btn-row-extend [buttonList]="colvalue.buttonList" [data]="data">
              </table-btn-row-extend>
            </ng-container>
            <ng-container *ngIf="colvalue.isShowButton === true">
              <table-btn-row-extend [buttonList]="colvalue.buttonList" [data]="data">
              </table-btn-row-extend>
            </ng-container>
            <div *ngIf="colvalue.key === 'color'" [style.background]="data[colvalue.key] ? data[colvalue.key] :  ''" class="color-col">
            </div>
          </td>
        </ng-container>
        <td 
          *ngIf="options.isBtnCol" 
          [nzRight]="options.numbernzRight >= 1 ? true : false ">
          <table-btn-row
            [isDeleteBtn]="options.isDeleteBtn"
            [isEditBtn]="options.isEditBtn"
            [isArrangeClassBtn]="options.isArrangeClassBtn"
            [isPasswordRecoveryBtn]="options.isPasswordRecoveryBtn"
            [isInfoBtn]="options.isInfoBtn"
            (delete)="deleteHanlder(data)"
            (info)="infoHanlder(data)"
            (edit)="editHanlder(data)"
            (arrangeClass)="arrangeClassHanlder(data)"
            (passwordRecovery)="passwordRecoveryHanlder(data)"
          >
          </table-btn-row>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
<ng-template #rangeTemplate let-range="range" let-total> {{ range[0] }}-{{ range[1] }} của {{ options.total }} </ng-template>